<template>
  <div>
    <question-renderer
      :question="src"
      :indicator="indicator"
    ></question-renderer>

    <div class="puzzle-zone">
      <div class="wordsearch_grid">
        <div class="d-flex" v-for="(rowV, row) in sizeInt" :key="`row_${row}`">
          <div
            class="d-flex justify-center"
            v-for="(colV, col) in sizeInt"
            :key="`${row}_${col}`"
          >
            <div
              :class="letterTileClasses(col, row)"
              :data-x="col"
              :data-y="row"
              class="d-flex"
              style="position: relative"
              @mousedown.prevent="wordSelectStart"
              @mouseup="wordSelectUpdate"
              @mousemove="wordSelectUpdate"
              @touchstart.prevent="wordSelectStart"
              @touchend="wordSelectUpdate"
              @touchmove="wordSelectUpdate"
            >
              <svg width="100%" height="100%" viewBox="0 -1 24 24">
                <text
                  x="50%"
                  dominant-baseline="middle"
                  y="50%"
                  text-anchor="middle"
                >
                  {{ gridVal(col, row) == "#" ? "" : gridVal(col, row) }}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-list dense outlined rounded class="mt-3">
      <v-subheader>รายการคำตอบ</v-subheader>
      <template v-for="(ans, idx) of wordList">
        <v-list-item :key="`ans_user_${idx}`">
          <v-list-item-title>{{ ans.text }}</v-list-item-title>
          <v-list-item-action v-if="!readOnly">
            <v-btn icon small @click="removeWord(ans, idx)">
              <v-icon small color="error">far fa-times</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="idx < wordList.length - 1"
          :key="`divider_user_wordLines_${idx}`"
        ></v-divider>
      </template>
    </v-list>

    <div id="correct-block" class="mt-4">
      <template v-if="showCorrectAnswer == true">
        <div class="title">เฉลย</div>
        <div class="puzzle-zone mt-3">
          <div class="wordsearch_grid">
            <div
              class="d-flex"
              v-for="(rowV, row) in sizeInt"
              :key="`row_${row}`"
            >
              <div
                class="d-flex justify-center"
                v-for="(colV, col) in sizeInt"
                :key="`${row}_${col}`"
              >
                <div
                  :class="letterTileClassesForCorrect(col, row)"
                  :data-x="col"
                  :data-y="row"
                  class="d-flex"
                  style="position: relative"
                >
                  <svg width="100%" height="100%" viewBox="0 -1 24 24">
                    <text
                      x="50%"
                      dominant-baseline="middle"
                      y="50%"
                      text-anchor="middle"
                    >
                      {{
                        gridValForCorrect(col, row) == "#"
                          ? ""
                          : gridValForCorrect(col, row)
                      }}
                    </text>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-list dense outlined class="mt-3" rounded>
          <v-subheader>รายการคำตอบ</v-subheader>
          <v-divider></v-divider>
          <template v-for="(ans, idx) of correctAnswer.correctPuzzle.wordList">
            <v-list-item :key="`ans_correct_${idx}`">
              <v-list-item-title>{{ ans.text }}</v-list-item-title>
            </v-list-item>
            <v-divider
              v-if="idx < correctAnswer.correctPuzzle.wordList.length - 1"
              :key="`divider_correct_wordList_${idx}`"
            ></v-divider>
          </template>
        </v-list>
      </template>
    </div>

    <v-overlay :value="overlay">
      <div class="text-center ma-4">
        <v-card light>
          <v-card-title>ระบุคำในแต่ละช่อง</v-card-title>
          <v-card-text>
            <div
              class="d-flex align-space-between justify-center"
              v-if="activeWord.length > 0"
            >
              <template v-for="(item, idx) in activeWord.length">
                <div :key="`input-each-letter-${idx}`">
                  <input
                    type="text"
                    class="letter-input"
                    v-model="activeWord[idx]"
                    maxlength="1"
                    :ref="`input_letter_${idx}`"
                    @keyup.enter="focusNext(idx)"
                    :disabled="lockActiveWord[idx]"
                  />
                </div>
                <div
                  class="px-2 title align-self-center"
                  v-if="idx < activeWord.length - 1"
                  :key="`div-each-letter-${idx}`"
                >
                  -
                </div>
              </template>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="overlay = false">ยกเลิก</v-btn>
            <v-btn
              text
              color="primary"
              :disabled="!fillAllTextBox"
              @click="setLetterInTable"
              >ตกลง</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  components: {
    QuestionRenderer,
  },
  data: () => ({
    selectedRange: {
      start: undefined,
      end: undefined,
    },
    usedTiles: [],
    letterGrid: [],
    overlay: false,
    lastDrag: null,
    activeWord: [],
    lockActiveWord: [],
    wordList: [],
    answer: {},
    correctGrid: {},
  }),
  computed: {
    sizeInt() {
      return this.src.puzzleGridSize;
    },
    fillAllTextBox() {
      let idx = this.activeWord.indexOf("");
      if (idx === -1) {
        return true;
      }
      return false;
    },
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correctPuzzle != null
      ) {
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  watch: {
    overlay(val) {
      if (val === false) {
        this.lastDrag = null;
      }
    },
    wordList: {
      deep: true,
      handler: function (val) {
        const data = {
          answer: val,
        };
        // console.log(data);
        this.$emit("interact", data);
      },
    },
    showCorrectAnswer(val) {
      if (val) {
        this.showCorrect();
      }
    },
  },
  mounted() {
    this.answer = {};
    this.init();
  },
  methods: {
    init() {
      this.usedTiles = [];
      this.letterGrid = this.src.puzzleGridQuestion;

      if (this.userAnswer != null) {
        this.answer = this.userAnswer;

        // redraw ui
        this.wordList = this.answer;
        for (let word of this.wordList) {
          let positions = this.$gameUtil.gridPositions(word.data);
          // add tile used
          let letter = word.text.split("");
          let idx = 0;
          for (let pos of positions) {
            // assign letter
            this.setGridVal(pos.x, pos.y, letter[idx]);
            this.usedTiles.push({
              x: pos.x,
              y: pos.y,
            });
            idx++;
          }
        }
      }
    },
    showCorrect() {
      // console.log(this.showCorrectAnswer);
      // redraw ui
      this.correctGrid = [];
      for (let i = 0; i < this.sizeInt; i++) {
        this.correctGrid.push([]);
        for (let j = 0; j < this.sizeInt; j++) {
          this.correctGrid[i].push("#");
        }
      }

      // place correct word
      for (let word of this.correctAnswer.correctPuzzle.wordList) {
        let positions = this.$gameUtil.gridPositions(word.data);
        // add tile used
        let letter = word.text.split("");
        // console.log(word)
        let idx = 0;
        for (let pos of positions) {
          // assign letter
          if (typeof this.correctGrid[pos.y] !== "undefined") {
            if (typeof this.correctGrid[pos.y][pos.x] !== "undefined") {
              this.correctGrid[pos.y][pos.x] = letter[idx].toUpperCase();
            }
          }
          idx++;
        }
      }

      this.$nextTick(() => {
        this.$vuetify.goTo("#correct-block");
      });
    },
    getAnswer() {
      this.answer = this.wordList;
      return this.answer;
    },
    //#region game methods
    focusNext(idx) {
      const el = this.$refs[`input_letter_${idx + 1}`];
      if (el != null && el.length > 0) {
        el[0].focus();
      } else {
        if (this.fillAllTextBox == true) {
          // auto close
          this.setLetterInTable();
        }
      }
    },
    setLetterInTable() {
      // check all word is lock
      if (this.lockActiveWord.indexOf(false) === -1) {
        this.overlay = false;
        return;
      }

      let positions = this.$gameUtil.gridPositions(this.lastDrag);
      // console.log(positions.entries());
      for (let i = 0; i < this.activeWord.length; i++) {
        this.setGridVal(positions[i].x, positions[i].y, this.activeWord[i]);

        // add tile used
        this.usedTiles.push({
          x: positions[i].x,
          y: positions[i].y,
        });
      }

      this.wordList.push({
        text: this.activeWord.join("").toUpperCase(),
        data: this.lastDrag,
      });
      // console.log(this.tableGame[this.lastDrag.game]);
      this.overlay = false;
    },
    showGridValueDialog() {
      if (this.readOnly === true) {
        this.lastDrag = null;
        return;
      }

      this.activeWord = [];
      this.lockActiveWord = [];

      let positions = this.$gameUtil.gridPositions(this.lastDrag);
      for (let pos of positions) {
        let val = this.gridVal(pos.x, pos.y);
        this.activeWord.push(val);
        if (val != "" && val != null) {
          this.lockActiveWord.push(true);
        } else {
          this.lockActiveWord.push(false);
        }
      }

      this.overlay = true;
      this.$nextTick(() => {
        this.$refs[`input_letter_0`][0].focus();
      });
    },
    removeWord(ans, index) {
      // remove tile
      let positions = this.$gameUtil.gridPositions(ans.data);
      // console.log(positions.entries());
      for (let i = 0; i < positions.length; i++) {
        let findUsedTile = this.usedTiles.filter(
          (pos) => pos.x == positions[i].x && pos.y == positions[i].y
        );

        if (findUsedTile != null) {
          // check is last tile
          if (findUsedTile.length == 1) {
            this.setGridVal(positions[i].x, positions[i].y, "");
          }

          // remove used tile -1
          let usedTileAtCell = this.usedTiles.findIndex(
            (pos) => pos.x == positions[i].x && pos.y == positions[i].y
          );
          if (usedTileAtCell !== -1) {
            this.usedTiles.splice(usedTileAtCell, 1);
          }
        }
      }

      this.wordList.splice(index, 1);
    },
    setGridVal(x, y, val) {
      // console.log(gameIdx, x, y, val);
      if (typeof this.letterGrid[y] !== "undefined") {
        if (typeof this.letterGrid[y][x] !== "undefined") {
          this.letterGrid[y][x] = val.toUpperCase();
        }
      }
    },
    gridVal(x, y) {
      if (typeof this.letterGrid[y] !== "undefined") {
        if (typeof this.letterGrid[y][x] !== "undefined") {
          return this.letterGrid[y][x].toUpperCase();
        }
      }
      return "";
    },
    gridValForCorrect(x, y) {
      if (typeof this.correctGrid[y] !== "undefined") {
        if (typeof this.correctGrid[y][x] !== "undefined") {
          return this.correctGrid[y][x].toUpperCase();
        }
      }
      return "";
    },
    letterTileClasses(x, y) {
      const classes = ["letter-tile"];
      if (this.isTileHighlighted(x, y)) {
        classes.push("letter-tile-highlighted");
      }
      // if (this.isTileAFoundWordTile(x, y)) {
      //   classes.push("letter-tile-found");
      // }

      let val = this.gridVal(x, y);
      if (val != "") {
        classes.push("letter-tile-hasText");
      }
      // if (val != "" && val != "#") {
      //   classes.push("letter-tile-hasText");
      // }
      if (val == "#") {
        classes.push("grey darken-1");
      }
      return classes;
    },
    letterTileClassesForCorrect(x, y) {
      const classes = ["letter-tile"];
      // if (this.isTileAFoundWordTile(x, y)) {
      //   classes.push("letter-tile-found");
      // }

      let val = this.gridValForCorrect(x, y);
      if (val != "") {
        classes.push("letter-tile-hasText");
      }
      // if (val != "" && val != "#") {
      //   classes.push("letter-tile-hasText");
      // }
      if (val == "#") {
        classes.push("grey darken-1");
      } else {
        classes.push("green lighten-5");
      }
      return classes;
    },
    isTileAFoundWordTile(x, y) {
      for (let i = 0; i < this.usedTiles.length; i += 1) {
        if (this.usedTiles[i].x === x && this.usedTiles[i].y === y) {
          return true;
        }
      }
      return false;
    },
    isTileHighlighted(x, y) {
      if (this.selectedRange.start && this.selectedRange.end) {
        const r = this.selectedRange;
        const minX = Math.min(r.start.x, r.end.x);
        const maxX = Math.max(r.start.x, r.end.x);
        const minY = Math.min(r.start.y, r.end.y);
        const maxY = Math.max(r.start.y, r.end.y);
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          // in range. If X or Y are equal then it's a straight line, otherwise
          // Work out diagonal logic.
          return r.start.x === r.end.x || r.start.y === r.end.y;
        }
      }
      return false;
    },
    wordSelectStart(event) {
      const touchedElement = event.target.closest("div.letter-tile");
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        this.selectedRange.start = {
          x: parseInt(touchedElement.dataset.x, 10),
          y: parseInt(touchedElement.dataset.y, 10),
        };
        return true;
      }
      return false;
    },
    wordSelectUpdate(event) {
      // We never started selecting, bail early.
      if (this.selectedRange.start === undefined) {
        return false;
      }
      let touch = event;
      if (event.type.indexOf("touch") === 0) {
        touch = event.changedTouches.item(0);
      }
      const tEl = document.elementFromPoint(touch.clientX, touch.clientY);
      if (!tEl) {
        return false;
      }
      const touchedElement = tEl.closest("div.letter-tile");
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        const x = parseInt(touchedElement.dataset.x, 10);
        const y = parseInt(touchedElement.dataset.y, 10);
        const dx = Math.abs(x - this.selectedRange.start.x);
        const dy = Math.abs(y - this.selectedRange.start.y);
        // Verify the end is valid.
        // If dy (change in y) or dx (change in x) is zero, then it is horizontal/vertcal == OK.
        // Or if dx === dy, then it is diagonal.
        if ((dy === 0 && dx > 0) || (dx === 0 && dy > 0) || dx === dy) {
          this.selectedRange.end = { x, y };
          // If it's mouseup, then we finished the dragging a range
          if (event.type === "mouseup" || event.type === "touchend") {
            // console.log(JSON.stringify(this.selectedRange)); // eslint-disable-line no-console
            this.guess = [];
            // Build guess!
            const sx = this.selectedRange.start.x;
            const sy = this.selectedRange.start.y;
            const ex = this.selectedRange.end.x;
            const ey = this.selectedRange.end.y;
            // 0 = up, 1 = up-right, 2 = right, 3 = down-right, 4 = down
            // 5 = down-left, 6 = left, 7 = up-left
            var direction = 0;
            if (dx === 0) {
              // Vertical
              const step = ey > sy ? 1 : -1;
              for (let i = sy; step > 0 ? i <= ey : i >= ey; i += step) {
                let val = this.gridVal(sx, i);
                if (val == "#") {
                  this.resetSelectedRange();
                  return;
                }
                this.guess.push({ x: sx, y: i });
              }
              direction = step > 0 ? 4 : 0;

              if (this.guess.length == 1) {
                this.resetSelectedRange();
                return;
              }
              const newWordLine = {
                x: sx,
                y: sy,
                length: this.guess.length,
                direction,
              };
              this.lastDrag = newWordLine;
              this.showGridValueDialog();

              this.resetSelectedRange();
            } else if (dy === 0) {
              // Horizontal
              const step = ex > sx ? 1 : -1;
              for (let i = sx; step > 0 ? i <= ex : i >= ex; i += step) {
                let val = this.gridVal(i, sy);
                if (val == "#") {
                  this.resetSelectedRange();
                  return;
                }
                this.guess.push({ x: i, y: sy });
              }
              direction = step > 0 ? 2 : 6;

              if (this.guess.length == 1) {
                this.resetSelectedRange();
                return;
              }
              const newWordLine = {
                x: sx,
                y: sy,
                length: this.guess.length,
                direction,
              };
              this.lastDrag = newWordLine;
              this.showGridValueDialog();

              this.resetSelectedRange();
            } else {
              this.resetSelectedRange();
            }
            // const newWordLine = {
            //     word: this.guessedWord,
            //     x: sx,
            //     y: sy,
            //     length: this.guessedWord.length,
            //     direction,
            //   };
          }
        } else if (event.type === "mouseup" || event.type === "touchend") {
          // Verify failed, reset range (only if at the end of a gesture)
          this.resetSelectedRange();
        } else {
          this.selectedRange.end = undefined;
        }
      } else if (event.type === "mouseup" || event.type === "touchend") {
        // End was "null" or had no x/y. Reset.
        this.resetSelectedRange();
      } else {
        this.selectedRange.end = undefined;
      }
      return true;
    },
    resetSelectedRange() {
      this.selectedRange = {
        start: undefined,
        end: undefined,
      };
    },
    //#endregion
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
  background-color: #e3e3e3;
}
.letter-input {
  width: 32px;
  height: 32px;
  border: 1px solid grey;
  padding: 4px;
  text-align: center;
  text-transform: uppercase;
}
.puzzle-zone ::v-deep div.wordsearch_grid {
  min-width: calc(90vw - 50px);
  background: #fff;

  @media screen and (min-width: 100vh) {
    min-width: calc(90vh - 50px);
  }

  > div {
    > div {
      border: 1px solid #d3d3d3;
      padding: 0;

      &:not(:last-child) {
        border-right-width: 0 !important;
      }

      > div {
        > svg {
          line-height: 1 !important;
          font-weight: normal !important;
        }
      }
    }

    &:not(:last-child) {
      > div {
        border-bottom-width: 0 !important;
      }
    }
  }
}

.letter-tile {
  padding: 0 0;
  cursor: pointer;
  //   svg {
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     line-height: 0;
  //     width: 100%;
  //     // fill: $body-color;
  //   }

  transition: background ease-in 0.1s;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &.letter-tile-found {
    background: rgba(0, 225, 255, 0.2);
  }
  &.letter-tile-highlighted {
    background: rgba(255, 255, 0, 0.2);
  }
  &.letter-tile-correct {
    background: rgba(0, 255, 0, 0.3) !important;
  }
}

.word-strike {
  height: 0;
  width: 100%;
  border: 1px solid #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 100;
  box-shadow: 0 0 7px #000;
  transform-origin: 0 0;

  @for $i from 0 to 7 {
    &.word-strike-direction-#{$i} {
      transform: rotate((($i * 45deg) - 90deg));
    }
  }
  @for $i from 0 to 20 {
    &:not(.word-strike-diagonal).word-strike-length-#{$i} {
      width: ($i - 1) * 100%;
    }
    &.word-strike-diagonal.word-strike-length-#{$i} {
      width: ($i - 1) * 100% * 1.414214;
    } // 1.414214 is a hypothenuse multiplier
  }
}
</style>